const routes = [
  {
    path: "/cliente/notificacoes",
    component: () => import("@/components/notificacao/Notificacao.vue"),
    meta: {
      title: "Notificação",
    },
  },
];

export default routes;
